(ns bec-data-format.core
  (:require [cognitect.transit :as transit]
            [cljc.java-time.instant]
            [cljc.java-time.duration]
            [cljc.java-time.period]
            [java.time]
            [ajax.util]
            [ajax.interceptors]
            [com.cognitect.transit.types]
            [bec-data-format.types :as types]))


(def readers
  {"class java.time.Instant" (transit/read-handler #(cljc.java-time.instant/parse %))
   "class java.time.Duration" (transit/read-handler #(cljc.java-time.duration/parse %))
   "class java.time.Period" (transit/read-handler #(cljc.java-time.period/parse %))
   "class java.lang.Class" (transit/read-handler #(types/->java_lang_Class %))
   "class java.lang.Throwable" (transit/read-handler types/map->java_lang_Throwable)
   "class clojure.lang.ExceptionInfo" (transit/read-handler types/map->clojure_lang_ExceptionInfo)
   "js/Function" (transit/read-handler types/map->JSFunction)
   "js/Error" (transit/read-handler types/map->JSError)
   })


(def writers
  (letfn [(js-error-handler [err] ;; We do not try to generate a stacktrace here, because we cannot do this proper: js/StackTrace.fromError uses a promise -- and js/StackTrace.getSync will not do source-mapping.
            {:type (.-name (type err)), :name (.-name err), :message (.-message err)})]

    {java.time/Instant (transit/write-handler (fn [_] "class java.time.Instant") str)
     java.time/Duration (transit/write-handler (fn [_] "class java.time.Duration") str)
     java.time/Period (transit/write-handler (fn [_] "class java.time.Period") str)
     js/Function (transit/write-handler (fn [_] "js/Function")
                                        #(let [ns_name (clojure.string/split (.-name %) #"\$")]
                                           {:name (str (clojure.string/join "." (butlast ns_name))
                                                       "/"
                                                       (last ns_name))}))
     js/Error (transit/write-handler (fn [_] "js/Error") js-error-handler)
     ;; TODO: Hmm, (instance? js/Error (new js/DOMException)) => true    ...but I still seem to need this. Weird.
     js/DOMException (transit/write-handler (fn [_] "js/Error") js-error-handler)
     cljs.core/ExceptionInfo (transit/write-handler (fn [_] "class clojure.lang.ExceptionInfo")
                                                    #(hash-map :message (ex-message %), :data (ex-data %), :cause (ex-cause %)))
     types/clojure_lang_ExceptionInfo (transit/write-handler (fn [_] "class clojure.lang.ExceptionInfo")
                                                             #(into {} %))
     }))


(defn pack "ClojureScript `data` => msg (JSON string)"
  [data]
  (transit/write (transit/writer :json {:handlers writers}) data))


(defn unpack "`msg` (JSON string) => ClojureScript data."
  [msg]
  (transit/read (transit/reader :json {:handlers readers}) msg))


(defn cljs-ajax-request-format []
  {:description "bec-df request format"
   :content-type "application/x-bec-df; charset=utf-8"
   :write (ajax.util/to-utf8-writer pack)})


(defn cljs-ajax-response-format []
  (ajax.interceptors/map->ResponseFormat
   {:description "bec-df response format"
    :content-type "application/x-bec-df; charset=utf-8"
    :read (fn [xhrio]
            (-> (ajax.protocols/-body xhrio)
                (unpack)))}))
